export const getLatestVersion = _ => {
  return 'v1.0.0'
}  
